import { render } from "./MarkdownRender.vue?vue&type=template&id=7a886696"
import script from "./MarkdownRender.vue?vue&type=script&lang=js"
export * from "./MarkdownRender.vue?vue&type=script&lang=js"

import "./MarkdownRender.vue?vue&type=style&index=0&id=7a886696&lang=less"
script.render = render

export default script